import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

const fetchCountries = async (filters) => {
  const { data } = await api.get("/v1/admin/countries", { params: filters });
  return data.data;
};

export const useCountries = (filters) =>
  useQuery({
    queryKey: ["admin-countries", filters],
    queryFn: () => fetchCountries(filters),
    refetchOnWindowFocus: false,
  });

const fetchGroupStatus = async () => {
  const { data } = await api.get("/v1/admin/countries/groups/status");
  return data.data;
};

export const useGroupStatus = () =>
  useQuery({
    queryKey: ["admin-countries-group-status"],
    queryFn: fetchGroupStatus,
    refetchOnWindowFocus: false,
  });

const refresh = (queryClient) => {
  queryClient.invalidateQueries({ queryKey: ["admin-countries"] });
  queryClient.invalidateQueries({ queryKey: ["admin-countries-group-status"] });
};

export const useUpdateCountry = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ uuid, payload }) => {
      const { data } = await api.patch(`/v1/admin/countries/${uuid}`, payload);
      return data.data;
    },
    onSuccess: () => refresh(queryClient),
  });
};

// Preview (nothing changes) or apply one group button.
export const useApplyGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ group, action, preview }) => {
      const { data } = await api.post(
        `/v1/admin/countries/groups/${group}`,
        { action },
        { params: preview ? { preview: true } : undefined }
      );
      return data.data;
    },
    onSuccess: (result) => {
      if (result.applied) refresh(queryClient);
    },
  });
};
